import { ContentBox } from "@msuite/ui/content-box";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { guardString } from "@msuite/utils/strings";
import type { MeasurementAccessType } from "@msuite/utils/types";
import { useParams } from "react-router";
import { client } from "@/hono";
import { useMemberBreadcrumbTitle } from "@/hooks/use-member-breadcrumb-title";
import { MeasurementsContext } from "./context";
import { columns } from "./table-config";

/** Props Interface */
interface MeasurementsProps {
	type: MeasurementAccessType;
}

export function Measurements({ type }: MeasurementsProps) {
	/** Hooks */
	const params = useParams();
	const userId = params?.userId;

	/** Query */
	const { data, isLoading, queryKey, refetch } = useQuery({
		queryKey: ["measurements", guardString(userId)],
		queryFn: async () => {
			const response = await client.measurements.user.overview.$get({
				query: {
					userId,
				},
			});
			const json = await responseHandler(response);
			return json.measurements;
		},
	});

	/** Effects */
	useMemberBreadcrumbTitle(userId);

	/** Render */
	return (
		<MeasurementsContext.Provider value={{ type, userId }}>
			<ContentBox>
				<DataTable
					data={guardArray(data)}
					columns={columns}
					persistenceKey="measurements-table"
					isLoading={isLoading}
					queryKey={queryKey}
					refetch={refetch}
					initialPinningState={{
						start: ["workspaceName"],
						end: ["progress", "actions"],
					}}
					menu={null}
				/>
			</ContentBox>
		</MeasurementsContext.Provider>
	);
}
